import { defineComponent as _defineComponent } from 'vue'
import { reactive, ref, watch, watchEffect } from 'vue'
import { useState } from 'vuex-composition-helpers'

import { useJobsSearch, useJobsSearchCount } from '@/components/jobs/search'
import { useOrderedJobColumns } from '@/components/jobs/columns'
import { useJobSideSheetNavigation } from '@/components/jobs/navigation'
import { useJobsCountQuery, useJobsQuery } from '@/components/jobs/query'
import { useDailyViewJobQueueFilters } from '@/components/jobs/filters'
import { usePagination } from '@/components/jobs/pagination'
import PriorityFilter from '@/components/common/PriorityFilter.vue'
import ColumnSelector from '@/components/common/ColumnSelector.vue'
import JobColumn from '@/components/jobs/JobColumn'
import TableSearch from '@/components/common/TableSearch.vue'
import VsSnackbar from '@/components/vision/VsSnackbar.vue'
import VsText from '@/components/vision/VsText.vue'
import VsButton from '@/components/vision/VsButton.vue'
import { useGetJobFilterOptions } from '@/api/filter-options'
import { until } from '@vueuse/core'
import { useScheduleFilterStore } from '@/components/schedule/ScheduleFilterStore'
import { useFilteredJobStoreLegacyAdapter } from '../jobs/job-search-page/filteredJobStore'
import JobSearchPagination from '@/components/jobs/job-search-page/JobSearchPagination.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'DailyScheduleJobQueue',
  setup(__props) {

document.title = 'Daily Jobs - IronSight'

const showSnackbar = ref(false)
const filters = useDailyViewJobQueueFilters()
const { getCurrentPage, updatePage } = usePagination()

const { headers } = useOrderedJobColumns()
const { saving: jobIsSaving } = useState('jobs', ['saving'])

// -------
// Queries
// -------
const query = reactive(useJobsQuery(filters, getCurrentPage, ref(20)))
const { jobs, error: searchError, isFetching, reFetch } = useJobsSearch(query)

const countQuery = reactive(useJobsCountQuery(filters))
const { count, countFetching, countRefetch } = useJobsSearchCount(countQuery)

const { selectedPriorities } = useFilteredJobStoreLegacyAdapter()
const { selectedJobNumber, handleRowClicked } = useJobSideSheetNavigation(
  'day-view',
  'sv-ticket-info-panel'
)

// -------
// store
// -------
const filterStore = useFilteredJobStoreLegacyAdapter()
const {
  updateSearch,
  updateFilterReset,
  updateShowStandbyUnits,
  updateShowOfflineUnits,
  search: scheduleFilterSearch,
} = useScheduleFilterStore()

const { isFetched: isFetchedFilterOptions } = useGetJobFilterOptions()

// -------
// Functions
// -------
const resetAllDayViewFilters = async () => {
  await until(isFetchedFilterOptions).toBe(true)

  updateSearch('')

  filterStore.$patch({
    selectedPriorities: [],
  })

  updateFilterReset(true)
  updateShowStandbyUnits(true)
  updateShowOfflineUnits(true)
}

function refreshJobs() {
  reFetch()
  countRefetch()
}

const handleUpdateSearch = (value: string) => {
  updateSearch(value)
  updatePage(1)
}

const handleUpdatePriorities = (value: []) => {
  filterStore.$patch({
    selectedPriorities: value,
  })
  updatePage(1)
}

// -------
// Watchers
// -------
watchEffect(() => {
  showSnackbar.value = !!searchError.value
})

watch(selectedPriorities, () => updatePage(1))

watch(
  Object.values(filters).filter((x) => x === 'priorities'),
  () => {
    updatePage(1)
  }
)

watch(jobIsSaving, (isSaving, wasSaving) => {
  if (wasSaving && !isSaving) {
    refreshJobs()
  }
})

return { __sfc: true,showSnackbar, filters, getCurrentPage, updatePage, headers, jobIsSaving, query, jobs, searchError, isFetching, reFetch, countQuery, count, countFetching, countRefetch, selectedPriorities, selectedJobNumber, handleRowClicked, filterStore, updateSearch, updateFilterReset, updateShowStandbyUnits, updateShowOfflineUnits, scheduleFilterSearch, isFetchedFilterOptions, resetAllDayViewFilters, refreshJobs, handleUpdateSearch, handleUpdatePriorities, PriorityFilter, ColumnSelector, JobColumn, TableSearch, VsSnackbar, VsText, VsButton, JobSearchPagination }
}

})